import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import EditAcountsModal from "../../../../components/editAccountsModal"
import EditAccountsModalSkeleton from "../../../../components/editAccountsModalSkeleton"
import BlackList from "../BlackList";
import UserErrorTransactions from "../UserErrorTransactions"
import DocumentsHistory from '../../../../components/documentsHistory/DocumentsHistory';
import UserNotes from '../userNotes/UserNotes';

import { useNotification } from '../../../../context/NotificationContext';
import BuyingEmailsForUser from './BuyingEmailsForUser';
import { useEditUserMutation, useGetSingleAccountQuery, useCreateAccountMutation } from '../../../../services/accountsApi';
import { createErrorMessage } from '../../../../utils/index';

import CreditCardsListWithTools from '../creditCard/CreditCardsListWithTools';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

function EditUser({ userId, modalIsOpen, closeModal, onEdit }) {

  const { showNotification } = useNotification();

  console.log("EditUser userId: ", userId);
  const [tabIndex, setTabIndex] = React.useState(0);

  const { data: userApiRes, isLoading: userApiIsLoading, error: userApiError, isFetching: userApiIsFetching } = useGetSingleAccountQuery(userId, { skip: !userId });
  let userDflt={}
  const [initEditUser, {isLoading: initEditUserIsLoading}] = useEditUserMutation();
  const [initCreateAccount] = useCreateAccountMutation();

  let user= userId ? userApiRes : userDflt;

  const doNotDroneBuy = user?.doNotDroneBuy;

  function localOnClose(){
    setTabIndex(0);
    closeModal();
  }

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  //API call for create,update, delete account
  async function editUserOnSubmit(userId, userObj) {
    let creatingNewUser = !userId;
    let text = creatingNewUser ? "Error creating New User" : "Error editing user";
    let status = "ERROR";
    // DFTL values


    try {
      let result;
      //TODO CALL CREATE USER API
      if (!creatingNewUser) { //editing user
        let { StnId, ...userObjCopy } = userObj;
        userObjCopy.id = userId; //TODO: check why this is needed, it should be in the userObj
        result = await initEditUser(userObjCopy).unwrap()
      } else {
        console.log("creating user: " , JSON.stringify(userObj))
        result = await initCreateAccount(userObj).unwrap()
      }

      console.log("user edited/created, ", result);
      text = creatingNewUser ? "User created successfully" : "User updated successfully";
      status = "OK";
      showNotification(text, 'success');
      if (onEdit) onEdit();
    } catch (e) {
      console.log("error creating/editing user: " + JSON.stringify(e));
      console.log(e);
      showNotification(createErrorMessage(e), 'error');
    }
  }

  function reSendVerificationEmailResult(wasSuccessful) {
    let text = wasSuccessful ? "Verification email has been sent." : "Error sending verification email";
    showNotification(text, wasSuccessful ? "success" : "error");
  }

  async function deleteUserOnSubmit(id) {

    let status = "ERROR";
    let text = "ERROR trying to delete the user"

    try {
      let res = await initEditUser({id, isDeleted: true}).unwrap();
      console.log("user Deleted: " , res)
      text = "User Deleted successfully";
      status = "OK";
    } catch (e) {
      console.log("error deleting user: " + e);
      console.log("error deleting user: " + JSON.stringify(e))
    } finally {
      showNotification(text, status);
    }
  }

  async function restoreUserOnSubmit(id) {

    let status = "ERROR";
    let text = "ERROR trying to Restore the user"

    try {
      let res = await initEditUser({id, isDeleted: false}).unwrap();
      console.log("user Restored: " , res)
      text = "User Restored successfully";
      status = "OK";
    } catch (e) {
      console.log("error restoring user: " + e);
      console.log("error restoring user: " + JSON.stringify(e))
    } finally {
      showNotification(text, status);
    }
  }

  return (
    <>
      <Modal
        sx={{ overflowY: 'auto' }}
        open={modalIsOpen}
        onClose={() => localOnClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style,
            margin: '1em',
            padding: "1em",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: { xs: "100%", sm: "90%", md: "80%", lg: "1060px", xl: "1060px" },
            backgroundColor: "var(--background-lightgray)",
            borderRadius: "1em",
          }}
        >
          {doNotDroneBuy && (
            <Box sx={{ color: "red", fontWeight: 700, fontSize: "1.5em", display: "flex", justifyContent: "center", width:'100%' }}
            >
              DO NOT USE ACCOUNT FOR DRONE BUYING
            </Box>
          )} 
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "var(--light-yellow)",
              width: "100%"
            }}
          >
            <Tabs
              value={tabIndex}
              onChange={handleChange}
              aria-label="basic tabs example"
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Edit Account" {...a11yProps(0)} />
              <Tab label="Buying Emails" {...a11yProps(1)} />
              <Tab label="Credit Cards" {...a11yProps(2)} />
              <Tab label="Distribution Rules" {...a11yProps(3)} />
              <Tab label="Documents" {...a11yProps(4)} />
              <Tab label="Notes" {...a11yProps(5)} />
              <Tab label="ERRORS" {...a11yProps(6)} />
            </Tabs>
          </Box>

          {/* tabs for edit Accounts on Admin tools */}
          <TabPanel value={tabIndex} index={0}>
            {
              userApiIsLoading || userApiIsFetching || initEditUserIsLoading ?
                <EditAccountsModalSkeleton /> 
                :
                <EditAcountsModal
                  user={user}
                  closeModal={localOnClose}
                  onDelete={deleteUserOnSubmit}
                  onRestore={restoreUserOnSubmit}
                  onSubmit={editUserOnSubmit}
                  reSendVerificationEmailResult={reSendVerificationEmailResult}
                />
            }
          </TabPanel>

          <TabPanel value={tabIndex} index={1} style={{ width: '100%' }}>
            <Box sx={{ width: 1 }} style={{ 'height': '450px' }}>
              <BuyingEmailsForUser userId={userId} />
            </Box>
          </TabPanel>

          <TabPanel value={tabIndex} index={2} style={{ width: '100%' }}>
            <Box sx={{ width: 1 }}>
              <CreditCardsListWithTools assignedUserId={userId}/>
            </Box>
          </TabPanel>

          <TabPanel value={tabIndex} index={3} style={{ width: '100%' }}>
            <Box sx={{ width: 1 }} >
              {
                userApiIsLoading || userApiIsFetching ?
                  <p>Loading...</p>
                  :
                  <BlackList user={user} />
              }
              
            </Box>
          </TabPanel>

          <TabPanel value={tabIndex} index={4} style={{ width: '100%' }}>
            <Box sx={{ width: 1 }} >
              {
                userApiIsLoading || userApiIsFetching ?
                  <p>Loading...</p>
                  :
                  <DocumentsHistory user={user} />
              }
              
            </Box>
          </TabPanel>

          <TabPanel value={tabIndex} index={5} style={{ width: '100%' }}>
            {
              userApiIsLoading || userApiIsFetching ?
                <p>Loading...</p>
                :
                <>
                  <Box sx={{ width: 1 }} style={{ display: "flex", justifyContent: "center" }}>
                    <UserNotes user={user} />
                  </Box>
                </>
            }
          </TabPanel>

          <TabPanel value={tabIndex} index={6} style={{ width: '100%' }}>
            {
              userApiIsLoading || userApiIsFetching ?
                <p>Loading...</p>
                :
                <>
                  <Box sx={{ width: 1 }}>
                    <UserErrorTransactions user={user} />
                  </Box>
                </>
            }
          </TabPanel>

        </Box>
      </Modal>
    </>
  )
}

EditUser.propTypes = {
  userOnEditing: PropTypes.object,
  setUserOnEditing: PropTypes.func.isRequired,
  editUserOnSubmit: PropTypes.func.isRequired,
  reSendVerificationEmailResult: PropTypes.func.isRequired,
};

export default EditUser;